import AcreBootstrapTable from 'components/Common/AcreBootstrapTable/AcreBootstrapTable';

export default AcreBootstrapTable;
